import { render, staticRenderFns } from "./taskTransaction.vue?vue&type=template&id=92d4e85c&scoped=true"
import script from "./taskTransaction.vue?vue&type=script&lang=js"
export * from "./taskTransaction.vue?vue&type=script&lang=js"
import style0 from "./taskTransaction.vue?vue&type=style&index=0&id=92d4e85c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d4e85c",
  null
  
)

export default component.exports